import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-selectable-pill',
  templateUrl: './selectable-pill.component.html',
  styleUrls: ['./selectable-pill.component.scss'],
})
export class SelectablePillComponent {
  @Input() Select!: boolean;
  @Input() Close!: boolean;
  @Input() text!: string;
  @Input() isSelected: boolean = false;
  @Input() disabled: boolean = false;
  @Output() Selected = new EventEmitter<void>();
  @Output() Closed = new EventEmitter<void>();

  select() {
    if (!this.Close && this.isSelected) this.Selected.emit();
    else if (!this.Close) this.Closed.emit();
  }
  close() {
    this.Closed.emit();
  }
}
